export interface PhotoRecord {
    id?: number;
    photo: File;
}

// Abre o crea la base de datos IndexedDB
export const openDatabase = (): Promise<IDBDatabase> => {
    return new Promise<IDBDatabase>((resolve, reject) => {
        const request = indexedDB.open("propertyDataDB", 1);

        request.onupgradeneeded = (e: IDBVersionChangeEvent) => {
            const db = (e.target as IDBRequest).result;
            if (!db.objectStoreNames.contains("photos")) {
                db.createObjectStore("photos", { keyPath: "id", autoIncrement: true });
            }
        };

        request.onsuccess = (e: Event) => {
            resolve((e.target as IDBRequest).result);
        };

        request.onerror = (e: Event) => {
            reject((e.target as IDBRequest).error);
        };
    });
};

// Guarda las fotos en IndexedDB
export const savePhotosToIndexedDB = async (photos: File[]): Promise<void> => {
    const db = await openDatabase();
    const transaction = db.transaction("photos", "readwrite");
    const store = transaction.objectStore("photos");

    photos.forEach((photo) => {
        store.add({ photo });
    });

    return new Promise<void>((resolve, reject) => {
        transaction.oncomplete = () => resolve();
        transaction.onerror = (e) => reject((e.target as IDBRequest).error);
    });
};

// Obtiene todas las fotos desde IndexedDB
export const getPhotosFromIndexedDB = async (): Promise<File[]> => {
    const db = await openDatabase();
    const transaction = db.transaction("photos", "readonly");
    const store = transaction.objectStore("photos");

    const request = store.getAll();
    return new Promise<File[]>((resolve, reject) => {
        request.onsuccess = () => resolve(request.result.map((item: PhotoRecord) => item.photo));
        request.onerror = (e) => reject((e.target as IDBRequest).error);
    });
};

export const deletePhotoFromIndexedDB = async (photoId: string): Promise<void> => {
    const db = await openDatabase();
    const transaction = db.transaction("photos", "readwrite");
    const store = transaction.objectStore("photos");

    store.delete(photoId);

    return new Promise<void>((resolve, reject) => {
        transaction.oncomplete = () => resolve();
        transaction.onerror = (e) => reject((e.target as IDBRequest).error);
    });
};



export const deleteAllPhotosFromIndexedDB = async (): Promise<void> => {
    const db = await openDatabase();
    const transaction = db.transaction("photos", "readwrite");
    const store = transaction.objectStore("photos");

    store.clear(); 

    return new Promise<void>((resolve, reject) => {
        transaction.oncomplete = () => resolve();
        transaction.onerror = (e) => reject((e.target as IDBRequest).error);
    });
};
